"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("../../../node_modules/graphql-tag/lib/index.js").gql`
  mutation generateDesignService(
    $dxClientId: String!
    $modelFinderSessionId: String
  ) {
    generateDesign(
      DXClientId: $dxClientId
      ModelFinderSessionId: $modelFinderSessionId
    ) {
      id
    }
  }
`;exports.generateDesign=e;
//# sourceMappingURL=queries.js.map
